export default "__VITE_ASSET__23abced4__"